import { VyStack } from '@vy/ui-design-system';
import { PricingSection, UpgradeOptionsSection } from '../sections';

export function CommissionVariant() {
  return (
    <VyStack sx={{ gap: 2.5 }}>
      <PricingSection />
      <UpgradeOptionsSection />
    </VyStack>
  );
}
